import { useSelector } from 'react-redux';
import { getUser } from 'store/selectors/auth.selector';
import { Roles } from 'modules/core/enums';

export const useIsRoleAllowed = (allowedRoles?: Roles[]): boolean => {
  const user = useSelector(getUser);

  return !allowedRoles || (!!user?.role && allowedRoles.includes(user.role));
};
